<template>
  <div>
    <el-card class="">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('integralWithdrawal.queryCondition') }}</div>
      </div>
      <div class="">
        <el-form :inline="true" :model="integralWithdrawalInfo.conditions" class="flex justify-start">
          <el-form-item>
            <el-input
              v-model="integralWithdrawalInfo.conditions.integralName"
              :placeholder="$t('integralWithdrawal.placeholder.integralName')"
              clearable
            />
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="integralWithdrawalInfo.conditions.amount"
              :placeholder="$t('integralWithdrawal.placeholder.amount')"
              clearable
            />
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="integralWithdrawalInfo.conditions.applyUserName"
              :placeholder="$t('integralWithdrawal.placeholder.applyUserName')"
              clearable
            />
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="integralWithdrawalInfo.conditions.applyUserTel"
              :placeholder="$t('integralWithdrawal.placeholder.applyUserTel')"
              clearable
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="_queryIntegralWithdrawalMethod">
              <i class="el-icon-search"></i>
              {{ $t('common.query') }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

      <el-card class="margin-top-sm">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('integralWithdrawal.title') }}</div>
      </div>
      <div class="">
        <el-table
          :data="integralWithdrawalInfo.applys"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="iwId"
            :label="$t('integralWithdrawal.table.id')"
            align="center"
          />
          <el-table-column
            prop="integralId"
            :label="$t('integralWithdrawal.table.integralId')"
            align="center"
          />
          <el-table-column
            prop="integralName"
            :label="$t('integralWithdrawal.table.integralName')"
            align="center"
          />
          <el-table-column
            prop="shopId"
            :label="$t('integralWithdrawal.table.shopId')"
            align="center"
          />
          <el-table-column
            prop="amount"
            :label="$t('integralWithdrawal.table.amount')"
            align="center"
          />
          <el-table-column
            prop="applyUserName"
            :label="$t('integralWithdrawal.table.applyUserName')"
            align="center"
          />
          <el-table-column
            prop="applyUserTel"
            :label="$t('integralWithdrawal.table.applyUserTel')"
            align="center"
          />
          <el-table-column
            prop="bankNum"
            :label="$t('integralWithdrawal.table.bankNum')"
            align="center"
          />
          <el-table-column
            prop="bankNumName"
            :label="$t('integralWithdrawal.table.bankNumName')"
            align="center"
          />
          <el-table-column
            prop="bankName"
            :label="$t('integralWithdrawal.table.bankName')"
            align="center"
          />
          <el-table-column
            prop="remark"
            :label="$t('integralWithdrawal.table.remark')"
            align="center"
          />
          <el-table-column
            prop="stateName"
            :label="$t('integralWithdrawal.table.stateName')"
            align="center"
          />
          <el-table-column
            prop="stateMsg"
            :label="$t('integralWithdrawal.table.stateMsg')"
            align="center"
          />
          <el-table-column
            :label="$t('common.operation')"
            align="center"
            width="150"
          >
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.state === 'W'"
                type="text"
                size="small"
                @click="_openEditIntegralWithdrawalModel(scope.row)"
              >
                {{ $t('common.audit') }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="integralWithdrawalInfo.conditions.page"
          :page-size="integralWithdrawalInfo.conditions.row"
          layout="total, prev, pager, next"
          :total="integralWithdrawalInfo.total"
        />
      </div>
    </el-card>

    <audit-integral-withdrawal ref="auditIntegralWithdrawal" @refresh="_listIntegralWithdrawals" />
  </div>
</template>

<script>
import { queryAdminIntegralWithdrawal } from '@/api/admin/integralWithdrawal/integralWithdrawalApi'
import AuditIntegralWithdrawal from '@/components/admin/auditIntegralWithdrawal/auditIntegralWithdrawal'

export default {
  name: 'IntegralWithdrawal',
  components: {
    AuditIntegralWithdrawal
  },
  data() {
    return {
      integralWithdrawalInfo: {
        applys: [],
        total: 0,
        records: 1,
        conditions: {
          page: 1,
          row: 10,
          integralId: '',
          integralName: '',
          amount: '',
          applyUserName: '',
          applyUserTel: ''
        }
      }
    }
  },
  created() {
    this._listIntegralWithdrawals()
  },
  methods: {
    async _listIntegralWithdrawals(page = 1, rows = 10) {
      this.integralWithdrawalInfo.conditions.page = page
      this.integralWithdrawalInfo.conditions.row = rows
      try {
        const res = await queryAdminIntegralWithdrawal(this.integralWithdrawalInfo.conditions)
        this.integralWithdrawalInfo.applys = res.data
        this.integralWithdrawalInfo.total = res.total
        this.integralWithdrawalInfo.records = res.records
      } catch (error) {
        console.error(error)
      }
    },
    _queryIntegralWithdrawalMethod() {
      this._listIntegralWithdrawals()
    },
    handleCurrentChange(val) {
      this._listIntegralWithdrawals(val, this.integralWithdrawalInfo.conditions.row)
    },
    _openEditIntegralWithdrawalModel(row) {
      this.$refs.auditIntegralWithdrawal.open(row)
    }
  }
}
</script>

<style scoped>
.ibox {
  margin-bottom: 20px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
}
.ibox-title {
  padding: 15px 20px;
  border-bottom: 1px solid #eee;
  min-height: 16px;
}
.ibox-content {
  padding: 20px;
}
</style>